import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import createTrack from 'services/actions/tracker_actions';
import TutorialContainer from 'components/organisms/tutorial';
import HelpVideoModal from 'components/molecules/help_video_modal';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { TutorialDataKey, tutorialsData } from './tutorials';
import { VideoDataKey, videosData } from './videos';
import { TrackDataKey, tracksData } from './tracks';

interface OpenTutorialProps {
  type: 'modal' | 'container';
  source: VideoDataKey | TrackDataKey | TutorialDataKey;
}

const OpenTutorial = (props: OpenTutorialProps) => {
  const { type, source } = props;
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [TutorialOpened, setTutorialOpened] = useState<boolean>(false);

  const tutorialsList = tutorialsData[source as TutorialDataKey];
  const videoUrl = videosData[source as VideoDataKey];
  const sourceTrack = tracksData[source as TrackDataKey];

  const filteredTutorialList =
    tutorialsList?.filter((item) => !item.requiresAlfaTester || profile?.alfa_tester) ?? [];

  const handleOpenModal = () => {
    setTutorialOpened(true);
    createTrack('Clicou no botão video tutorial', { fonte: sourceTrack });
  };

  const textBySource: Record<string, string> = {
    dashboard: 'Veja como funciona o novo dashboard',
    dashboard_beginner: 'Veja como funciona o novo dashboard',
    monitoring: '',
  };

  const textButton = textBySource[source] ?? 'Veja como funciona';

  const classBySource: Record<string, string> = {
    monitoring:
      'btn btn-secondary btn-sm mr-1 d-flex align-items-center position-relative databalloon',
  };

  const classButton = classBySource[source] ?? 'btn btn-link p-0 btn-sm d-flex align-items-center';

  const extraAttrs =
    source === 'monitoring'
      ? {
          'aria-label': 'Veja como funciona o Monitorar Chat',
          'data-balloon-pos': 'down',
          'data-balloon-blunt': true,
        }
      : {};

  return (
    <>
      <button
        type="button"
        className={classButton}
        onClick={() => {
          handleOpenModal();
        }}
        {...extraAttrs}
      >
        <i className="material-icons mr-1">videocam</i>
        <h6 className="m-0">{textButton}</h6>
      </button>

      {type === 'container' && filteredTutorialList.length > 0 && (
        <TutorialContainer
          TutorialOpened={TutorialOpened}
          setTutorialOpened={setTutorialOpened}
          Tutorial={filteredTutorialList}
        />
      )}

      {type === 'modal' && videoUrl && (
        <HelpVideoModal
          modalVideoOpened={TutorialOpened}
          setModalVideoOpened={setTutorialOpened}
          urlVideo={videoUrl}
        />
      )}
    </>
  );
};

export default OpenTutorial;
